import { render, staticRenderFns } from "./demo-footer.vue?vue&type=template&id=405faa62&scoped=true&"
import script from "./demo-footer.vue?vue&type=script&lang=js&"
export * from "./demo-footer.vue?vue&type=script&lang=js&"
import style0 from "./demo-footer.vue?vue&type=style&index=0&id=405faa62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405faa62",
  null
  
)

export default component.exports